import { LoadingCircular } from "@metatrustlabs/ui-base";
import PublicPageLayout from "components/layout/PublicPage";
import { useKeycloak } from "hooks/useKeycloak";
import Head from "next/head";
import { NextPageWithLayout } from "./_app";

const SignUp: NextPageWithLayout = () => {
  const {
    actions: { login },
  } = useKeycloak();

  login({ redirectUri: process.env.NEXT_PUBLIC_SITE_HOME });

  return (
    <LoadingCircular className="mx-auto mt-24 h-12 w-12 text-orange-500" />
  );
};

SignUp.layout = function (props) {
  return (
    <PublicPageLayout showBgImage={true} showHeader={false} {...props}>
      <Head>
        <meta property="og:title" content="MetaScan - Sign In" />
        <meta property="og:type" content="type tag (website)" />
        <meta
          property="og:description"
          content="MetaScan uses a revolutionary approach designed to be developer-first. It combines multiple state-of-art security scanning engines into one single platform with unprecedented speed and accuracy, securing every aspect of your application beyond the smart contract layer."
        />
        <meta property="og:url" content="https://app.metatrust.io/sign-in" />
        <meta
          property="og:image"
          content="https://storage.googleapis.com/metatrust/metascan/og-cover.png"
        />
      </Head>
      {props.children}
    </PublicPageLayout>
  );
};

export default SignUp;
